import React, { useEffect } from 'react';
import './App.css';
import { GlobalStyles, Container, Content, Table } from './ui';
import Hugo, { useHugoState } from './hugo';
import {
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Navigation from './navigation';
import Startpage from './startpage';
import CV from './cv';
import Contact from './contact';
import Music from './music';
import { Breakout } from './game';
import Imprint from './imprint';


const App = ()  => {
  const [hugoState, hugoApi] = useHugoState({})
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location])

  return (
    <>
      <GlobalStyles />
        <Container>
          <Navigation />
          <Content>
            <Routes>
              <Route path="/" element={<Startpage hugoApi={hugoApi} />}/>
              <Route path="/cv" element={<CV hugoApi={hugoApi} />}/>
              <Route path="/_music" element={<Music hugoApi={hugoApi} />}/>
              <Route path="/game/_breakout" element={<Breakout hugoApi={hugoApi} />}/>
              <Route path="/contact" element={<Contact hugoApi={hugoApi} />}/>
              <Route path="/_imprint" element={<Imprint hugoApi={hugoApi} />}/>
            </Routes>
          </Content>
          <Table />
      <Hugo>{hugoApi.render(hugoState.output, hugoState.shaders, hugoState.plugins)}</Hugo>
      </Container>
    </>
  );
}

export default App;
